import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiserviceService } from '../../../../../../src/app/apiservice.service';

@Component({
  selector: 'app-process-execution-tracker',
  templateUrl: './process-execution-tracker.component.html',
  styleUrls: ['./process-execution-tracker.component.scss']
})
export class ProcessExecutionTrackerComponent {
  // Configuration object for button actions and styles
  buttonConfig = {
    action: [
      {
        label: "Restart Process",
        action: (element) => this.restartProcess(element), // Function to accept request
        style: {
          border: "1px solid #dc3545",
          color: "#ffffff",
          padding: "5px 10px",
          width: "110px",
          backgroundColor: "#dc3545",
          hover: {
            backgroundColor: "#dc3545",
          },
        },
      }
    ],
  };
  selectedData: any[]; // Array to hold fetched data
  displayColumns = [
    "upload_id",
    "club_id",
    "status",
    "action",
  ];

  processList = [
    // { upload_id: 12, club_id: 1, status: 1 },
    // { upload_id: 13, club_id: 2, status: 2 },
    // { upload_id: 14, club_id: 3, status: -1 },
    // { upload_id: 15, club_id: 1, status: 1 },
  ];
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProcessExecutionTrackerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly api: ApiserviceService
  ) {

  }
  ngOnInit(): void {
    if (this.data?.rowData) {
      this.fetchProcessClusterwise(this.data?.rowData?.id, this.data?.selectedProcess);
    }
  }

  // Method to get CSS class and color based on status code
  getStatusClass(status: any): { class: string; color: string } {
    // Mapping of status codes to classes and colors
    const StatusClassMap = {
  "1": { class: "Running",  color: "blue" },
  "2": { class: "Success",  color: "green" },
  "4": { class: "Synced",   color: "green" },
  "3": { class: "Syncing",  color: "gray" },
  "-1": { class: "Failed",  color: "red" },
  "-2": { class: "Stopped", color: "red" },
  "0": { class: "Started",  color: "blue" },
  "7": { class: "Running", color: "blue" }, // This status code is created solely for UI purposes as per the requirement.
    };
    return (
      StatusClassMap[status] || { class: "status-default", color: "black" }
    );
  }
  onClose(isTrue = null) {
    this.dialogRef.close(isTrue)
  }

  fetchProcessClusterwise(upload_id, process): void {
    const currentStatus = this.data?.rowData.status;
    const updatedDate = new Date(this.data?.rowData?.updated_date);
    const currentDate = new Date();

    // Calculate time difference in milliseconds
    const timeDiffMs = currentDate.getTime() - updatedDate.getTime();

    let url = `process-clusterwise?upload_id=${upload_id}&process=${process}`;
    this.isLoading = true;
    this.api.getGesData(url).subscribe({
      next: (response: any) => {
            // Update the status in the response data if condition is met
    this.processList = response?.data?.map((item: any) => {
      // If status is 1 and time gap is >= 24 hours, set custom status
      if (currentStatus === 1 && timeDiffMs >= 24 && item.status == 1) {
        return {
          ...item,
          status: 7, // ← Your custom UI-only status code
        };
      }
      return item;
    });
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching process data:', error);
        this.isLoading = false;
      }
    });
  }

  restartProcess(element: any): void {
    let url = `process-clusterwise/update-status`;
    const payload = {
      upload_id: element.upload_id,
      status: 0, // assuming 0 means "restart"
      club_id: element.club_id,
      common_db_city_id: 253
    };
    this.isLoading = true;
    this.api.patchGesData(url, payload).subscribe({
      next: (res: any) => {
        // Optionally refresh the list
        this.isLoading = false;
        this.fetchProcessClusterwise(payload.upload_id, 'cluster'); // or any current process name
        this.onClose(true)
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error restarting process:', err);
      }
    });
  }

}

